var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgBurgerOpen = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 43,
    viewBox: "0 0 34 43",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.5469 27.6383C31.4842 27.6383 32.244 26.8785 32.244 25.9413C32.244 25.004 31.4842 24.2442 30.5469 24.2442L18.6675 24.2442H15.2734L3.39401 24.2442C2.45675 24.2442 1.69695 25.004 1.69695 25.9413C1.69695 26.8785 2.45675 27.6383 3.39401 27.6383L15.2734 27.6383H18.6675L30.5469 27.6383Z",
    fill: "#113D18"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.5702 18.7166C31.5074 18.72 32.2699 17.9629 32.2733 17.0257C32.2767 16.0884 31.5197 15.3259 30.5824 15.3225L18.7031 15.2795L15.309 15.2673L3.4297 15.2243C2.49245 15.2209 1.72991 15.978 1.72652 16.9152C1.72313 17.8525 2.48018 18.615 3.41743 18.6184L15.2967 18.6614L18.6908 18.6736L30.5702 18.7166Z",
    fill: "#113D18"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBurgerOpen, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/burger-open.5c0ce80d.svg";
export { ForwardRef as ReactComponent };